export default __webpack_public_path__ + "static/media/chrome_icon.07ec0367.png";